// ----------------------------------------------------------------------
// <copyright file="Izenda.DebouncedInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { debounce } from 'lodash/fp';
import { DEFAULT_DEBOUNCE_TIME } from 'logic/data/Izenda.UIConstants';

class DebouncedInput extends Component {
  static propTypes = {
    onChangeValue: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    disabled: false
  };

  constructor(props) {
    super(props);
    const { onChangeValue, value } = props;

    this.state = {
      input: value
    };

    this.onChangeWithDebounce = debounce(DEFAULT_DEBOUNCE_TIME, input => {
      onChangeValue(input);
    });
  }

  handleInputChange = e => {
    e.persist();
    const { value } = e.target;

    this.setState({ input: value });
    this.onChangeWithDebounce(value);
  };

  render() {
    const { input } = this.state;
    const { disabled } = this.props;
    return (
      <input className="form-control" type="text" value={input} onChange={this.handleInputChange} disabled={disabled} />
    );
  }
}

export default DebouncedInput;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DebouncedInput.js